import { Badge, Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import { CircleCheck, CircleOff, OctagonX, RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";
import { IntegrationTestSuiteExecution } from "../../../../models/MappingTests";
import { palette } from "../../../../styles/theme/colors";
import { usePublishModuleContext } from "../context/PublishModuleContext";
import { countIntegrationTestSuiteMappingTestExecutionFailures } from "../publishModuleUtils";

const MappingTestAccordionTitleV2 = () => {
  const {
    onRunTestsForStagedIntegrationVersion,
    integrationTestSuiteExecution,
    isRunningMappingTests,
  } = usePublishModuleContext();
  const [failureCount, setfailureCount] = useState<number>(0);

  useEffect(() => {
    setfailureCount(
      integrationTestSuiteExecution
        ? countIntegrationTestSuiteMappingTestExecutionFailures(integrationTestSuiteExecution)
        : 0
    );
  }, [integrationTestSuiteExecution]);

  const hasMappingTestExecutions = (
    integrationTestSuiteExecution: IntegrationTestSuiteExecution | null
  ): boolean =>
    (integrationTestSuiteExecution?.linked_account_test_suite_executions ?? []).some(
      (testSuiteExecution) => (testSuiteExecution.mapping_test_executions?.length ?? 0) > 0
    );

  return (
    <div className="flex flex-row justify-between w-full">
      <div className="flex flex-row justify-start items-center space-x-3">
        {isRunningMappingTests ? (
          <RefreshCw className="rotating" color={palette.blue} size={16} />
        ) : !hasMappingTestExecutions(integrationTestSuiteExecution) ? (
          <CircleOff size={16} className="text-gray-40" />
        ) : failureCount > 0 ? (
          <OctagonX size={16} className="text-red-70" />
        ) : (
          <CircleCheck size={16} className="text-teal-70" />
        )}
        <Text variant="h5" className="text-black">
          Mapping tests
        </Text>
        {!isRunningMappingTests && failureCount > 0 && (
          <Badge color="red">
            {failureCount.toString() + (failureCount > 1 ? " failures" : " failure")}
          </Badge>
        )}
      </div>
      <div className="mr-6">
        <Button
          size="sm"
          variant={ButtonVariant.TertiaryWhite}
          leftIcon={<RefreshCw className={isRunningMappingTests ? "rotating" : ""} size={12} />}
          disabled={isRunningMappingTests}
          onClick={(e) => {
            e.stopPropagation();
            onRunTestsForStagedIntegrationVersion();
          }}
        >
          Re-run
        </Button>
      </div>
    </div>
  );
};

export default MappingTestAccordionTitleV2;
